import React from 'react';

const EmailSVG = ({ width, height, fill, style }) => {
	const viewBoxValues = "0 0 120 95.2";

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.64 10.3" width={width} height={height} fill={fill}>
            <path class="cls-1" d="M0,1.12.12.75,4.54,5.14.11,9.52,0,9.18Z"/>
            <path class="cls-1" d="M.74.11c.17,0,.32-.08.47-.1H13.27c.2,0,.4.05.6.08l.05.09c-.05,0-.11,0-.14.07l-6,6.06a.52.52,0,0,1-.83,0L.86.24Z"/>
            <path class="cls-1" d="M.76,10.18,5.19,5.8,6.35,7a1.33,1.33,0,0,0,1.56.28,1.49,1.49,0,0,0,.41-.3l1-1,.09-.09,4.45,4.4-.46.11H1.38A1.35,1.35,0,0,1,.76,10.18Z"/>
            <path class="cls-1" d="M14.54,9.56,10.1,5.16,14.54.76a2.11,2.11,0,0,1,.1.5q0,3.9,0,7.78A2.51,2.51,0,0,1,14.54,9.56Z"/>
        </svg>
	);
}

export default EmailSVG;


// WEBPACK FOOTER //
// ./src/components/common/svgs/EmailSVG.js